// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalPersonal_backdrop__kGa7S","container":"ModalPersonal_container__0y-fY","chatContainer":"ModalPersonal_chatContainer__fjJJG","chat":"ModalPersonal_chat__8JiAn"};